import React from "react";
import PersonIcon from '@material-ui/icons/Person';
import EventIcon from '@material-ui/icons/Event';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import ReceiptIcon from '@material-ui/icons/Receipt';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import HistoryIcon from '@material-ui/icons/History';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import ItemMenuTooltip from "./ItemMenuTooltip";
import { RenderTransition } from "../../../common/RenderTransition";
import MenuClose from "./MenuClose";
import { useSelector } from "react-redux";
import VpnKeyIcon from '@material-ui/icons/VpnKey';

const ListItemClose = () => {

    const { user } = useSelector(state => state.auth)

    const pharmacy = [
        {
            name: "Solicitud medicamentos",
            to: "request-pharmacy"
        }, 
        {
            name: "Historial de consumo",
            to: "consumption-history"
        },
        {
            name: "Stock de medicamentos",
            to: "stock-medicines"
        },
    ]

    const providers = [
        {
            name: "Prestadores internos",
            to: "internal-provider"
        },
        {
            name: "Prestadores externos",
            to: "external-provider"
        },
    ]

    const currentAccount = [
        {
            name: "Deuda actual",
            to: "current-debt"
        },
        {
            name: "Deuda histórica",
            to: "historical-debt"
        },
    ]

    return (<RenderTransition>
            <ItemMenuTooltip to={"/affiliate"} title={"Afiliado"} icon={<PersonIcon />} />
            <ItemMenuTooltip to={"/shifts"} title={"Turnos"} icon={<EventIcon />} />
            <ItemMenuTooltip to={"/orders"} title={"Órdenes"} icon={<ReceiptIcon />} />
            <MenuClose submenus={pharmacy} title={"Farmacia"} icon={<LocalHospitalIcon />} />
            <ItemMenuTooltip to={"/audit"} title={"Auditoria médica"} icon={<VerifiedUserIcon />} />
            <MenuClose submenus={providers} title={"Prestadores"} icon={<PermContactCalendarIcon />} />
            <ItemMenuTooltip to={"/refunds"} title={"Reintegros"} icon={<HistoryIcon />} />
            {user.titular && <MenuClose submenus={currentAccount} title={"C. Corriente"} icon={<AccountBalanceWalletIcon />} />}
            <ItemMenuTooltip to={"/contact"} title={"Contacto"} icon={<ContactSupportIcon />} />
        {user.titular && <MenuClose title={"Token"} icon={<VpnKeyIcon />} />}
    </RenderTransition>)
}

export default ListItemClose;

